export const getStartCase = (input: string, countType?: string): string => {
  const inputRes = input
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/[_\-]+/g, " ")
    .replace(/[^a-zA-Z0-9 ]+/g, "")
    .replace(/\s+/g, " ")
    .trim()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
  return `${inputRes}${countType === "plural" ? "s" : ""}`;
};

export function normalizeToLowercase(text: string, countType?: string): string {
  if (!text) return "";

  const inputRes = text
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/([A-Z])([A-Z][a-z])/g, "$1 $2")
    .toLowerCase()
    .trim()
    .replace(/\s+/g, " ");
  return `${inputRes}${countType === "plural" ? "s" : ""}`;
}
